import React from "react";
import { observer, inject } from "mobx-react";
import { customToast} from "../../store/ViewStore/Utils"
import DecretoService from "../decreto/service"
import Exportacao from './index'
import BaseContainer from "../../container/BaseContainer";
import Grid from "./grid";

@inject("stateStore", "relatorioStore")
@observer
class Container extends BaseContainer {

    constructor(props) {
        super(props);

        this.stateStore = this.props.stateStore
        this.gridStore = this.props.relatorioStore

        DecretoService._token = this._stateStore.apiToken

        this._gridStore.clearState()
        this.fetchRows()
        this.decretos()
    }

    async decretos() {
        const { data: { rows: decretos } } = await this.getDecretos()
        this._gridStore.setDecretoSelect(decretos)
    }

    async getDecretos() {
        return await DecretoService.fetch()
    }

    async downloadReport(decretoId, origemName, origemId, competencia) {
        
        try {
            this._gridStore.setState("pending")

            let reportName = decretoId === 'cbff9df4-d596-458c-897e-1ab85189ecd5'
                ? 'Produtividade_ACS'
                : 'Produtividade'

            const formData = new FormData()
            formData.append('ORIGEM_ID', origemId)
            formData.append('COMPETENCIA', competencia)
            formData.append('RETIFICACAO', false)
            formData.append('reportName', reportName)

            const params = { method: 'POST', body: formData }

            reportName = `${reportName}_${origemName.replace(/\s+/g, '_')}_${competencia}.pdf`

            await this._stateStore.download('api/v1/relatorio/generate', reportName, params)
        } catch (error) {
            customToast['error']('Não foi possível gerar o relatório. Entre em contato com o suporte.')
        } finally {
            this._gridStore.setState("done")
        }
    }

    render() {
        const gridComponent = (
            <Grid
                isLoading={this._gridStore.state === 'pending'}
                onChangePage={(page) => this.onChangePage(page)}
                downloadReport={(decretoId, origemName, origemId, competencia) => this.downloadReport(decretoId, origemName, origemId, competencia)}
                store={this._gridStore}
            />
        );
        return (
            <Exportacao
                component={gridComponent}
            />
        );
    }
}

export default Container;